import React, { useCallback, useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { useAuth } from "../context/AuthContext";

export default function PortfolioAccounts() {
  const { user } = useAuth();
  const [accounts, setAccounts] = useState([]);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const loadAccounts = useCallback(async () => {
    if (!user) {
      setAccounts([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError("");

    const { data, error: loadError } = await supabase
      .from("accounts")
      .select("*")
      .eq("user_id", user.id)
      .order("created_at", { ascending: false });

    if (loadError) {
      setError(loadError.message);
      setLoading(false);
      return;
    }

    setAccounts(data || []);
    setLoading(false);
  }, [user]);

  async function handleCreateAccount(e) {
    e.preventDefault();
    if (!name.trim() || !user) return;

    setSaving(true);
    setError("");

    const { error: insertError } = await supabase.from("accounts").insert([
      {
        user_id: user.id,
        name: name.trim(),
      },
    ]);

    if (insertError) {
      setError(insertError.message);
      setSaving(false);
      return;
    }

    setName("");
    setSaving(false);
    loadAccounts();
  }

  useEffect(() => {
    loadAccounts();
  }, [loadAccounts]);

  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: 24 }}>
      <h1>Portfolio Accounts</h1>
      <p>Create saved conviction accounts tied to your login.</p>

      <form
        onSubmit={handleCreateAccount}
        style={{ display: "flex", gap: 12, marginTop: 20, marginBottom: 24 }}
      >
        <input
          type="text"
          placeholder="Account name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ flex: 1, padding: 12 }}
        />
        <button type="submit" disabled={saving} style={{ padding: "12px 18px" }}>
          {saving ? "Creating..." : "Create Account"}
        </button>
      </form>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {loading ? (
        <p>Loading accounts...</p>
      ) : accounts.length === 0 ? (
        <p>No accounts yet.</p>
      ) : (
        <div style={{ display: "grid", gap: 12 }}>
          {accounts.map((account) => (
            <div
              key={account.id}
              style={{
                border: "1px solid #ddd",
                borderRadius: 10,
                padding: 16,
                background: "#fff",
              }}
            >
              <div style={{ fontWeight: 700 }}>{account.name}</div>
              <div style={{ fontSize: 13, color: "#666", marginTop: 4 }}>
                Created: {new Date(account.created_at).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}